import { swRequest } from "./sw-request";

export const getCandidate = ({ candidateId, fromCache = false }, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/get",
      method: "GET",
      params: { candidateId, fromCache, source: "candidates" },
    },
    opts,
  );

export const saveCandidate = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/save",
      method: "POST",
      body,
    },
    opts,
  );

export const modifyCandidates = (body) =>
  swRequest({
    path: "/api/candidates/modify",
    method: "POST",
    body,
  });

export const startSearches = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/start_searches",
      method: "POST",
      body,
    },
    opts,
  );

export const getSearches = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/get_searches",
      method: "POST",
      body,
    },
    opts,
  );

export const queryCandidates = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/query",
      method: "POST",
      body,
    },
    opts,
  );

export const pushToCrm = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/push_to_crm",
      method: "POST",
      body,
    },
    opts,
  );

export const getProjects = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/get_projects",
      method: "POST",
      body,
    },
    opts,
  );

export const getCandidateHistory = (candidateId, kind, opts = {}) =>
  swRequest(
    {
      path: "/api/candidates/get_history",
      method: "GET",
      params: { candidateId, kind },
    },
    opts,
  );

export const searchCandidates = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/dialler/search_candidates",
      method: "POST",
      body,
    },
    opts,
  );
